import React, {useState, useContext, useEffect, useMemo} from 'react';

// import { Container } from './styles';
import {Draggable} from 'react-beautiful-dnd';
import {useTranslation} from 'react-i18next';
import {Context} from '../../../../Helpers/Auth';
import WhatshotRoundedIcon from '@mui/icons-material/WhatshotRounded';
import CrisisAlertOutlinedIcon from '@mui/icons-material/CrisisAlertOutlined';

function Cards({info, index, handleRowClick}) {
    const {t} = useTranslation();
    const getItemStyle = (isDragging, draggableStyle) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: 'none',
        padding: 16,
        marginBottom: '2.5%',
        marginTop: '2.5%',
        display: 'grid',
        borderRadius: '10px',
        // placeItems: "center",
        ...draggableStyle,
    });
    const {utilizador, theme, rep, formatarNumero} = useContext(Context);

    return (
        <Draggable
            key={info.id}
            draggableId={info.num}
            index={index}
            // isDragDisabled={detalhe}
        >
            {(provided, snapshot) => (
                <>
                    <div
                        onClick={() => {
                            handleRowClick(info);
                        }}
                        // className="card noselect"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                        className={`flex flex-col card noselect bg-gray-200 border rounded-[8px] dark:text-white shadow-md hover:shadow-lg transition-transform transform hover:-translate-y-1 hover:scale-120 ${
                            theme == 'dark' ? 'dark:bg-gray-800 dark:border-gray-800 dark:hover:shadow-lg ' : ''
                        }`}>
                        <div className="flex flex-row items-center ">
                            <div className="flex items-center">
                                <span className="text-sm font-bold mr-2">{info.nome}</span>
                                {info.hotDeal == true && (
                                    <span className="text-sm font-bold text-red-600">
                                        Hot Deal <WhatshotRoundedIcon className="mb-2" />
                                    </span>
                                )}
                            </div>
                        </div>
                        {info.urgente && (
                            <div className="flex justify-start items-center">
                                <span className="flex font-bold text-[9px] items-center rounded-full px-1 bg-orange-400  dark:text-black">
                                    {t(`propostaUrgente`)}
                                    <CrisisAlertOutlinedIcon className="ml-2" />
                                </span>
                            </div>
                        )}

                        <div className="flex mt-2 items-center ">
                            <span className="font-bold text-xs  rounded-full px-1 bg-blue-400  dark:text-black">
                                {/* {new Intl.NumberFormat('de-DE', {
                                    style: 'currency',
                                    currency: 'EUR',
                                }).format(info.valor)} */}
                                {formatarNumero(info.valor)} €
                            </span>
                        </div>
                        <div className="flex flex-row justify-between items-center">
                            {' '}
                            <span className="text-xs mt-2 ">{info.empresa}</span>
                            <span className="text-md mt-2 font-semibold">{info.status?.label}</span>
                        </div>
                    </div>
                </>
            )}
        </Draggable>
    );
}

export default Cards;
